import * as Sentry from '@sentry/browser';
import { getConfig, cookie } from '@olxeu-a2b/delivery-utils/src/extras';
import { EnvironmentConfig } from '@olxeu-a2b/delivery-utils/typings/config';
import { USER_ID_COOKIE } from '@olxeu-a2b/core/src/utils/cookie';

const {
  environment,
  sentry: { dsn },
}: EnvironmentConfig = getConfig();

interface AppEnv {
  release?: string;
}

const appEnv = process.env.APP as AppEnv;

const config: Sentry.BrowserOptions = {
  environment,
  release: appEnv.release,
  dsn,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.01,
  integrations: [
    new Sentry.Replay({
      blockAllMedia: true,
      maskAllText: true,
      maskAllInputs: true,
    }),
  ],
};

export const setup = (): void => {
  if (environment === 'localhost') {
    return;
  }

  Sentry.init(config);

  const id = cookie.get(USER_ID_COOKIE);
  if (id) {
    Sentry.configureScope(scope => scope.setUser({ id }));
  }

  const fingerprint = cookie.get('fingerprint');
  if (fingerprint) {
    Sentry.configureScope(scope => scope.setFingerprint([fingerprint]));
  }
};

export default { setup };
